import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../../actions/root_url';

export const dispatchBindWithSCMUser = (data, callback) => {
  axios({
    method: 'PUT',
    data,
    url: `${ROOT_URL}v1/baseuser/set-dispatcher`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    callback();
  }, err => {
    alert(err);
  })
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/userManagement/dispatcherBind/redux.jsx